const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'Europe/Madrid',
};

const estadoComercial = {
    ALTA: 'success',
    BAJA: 'warning',
    INACTIVO: 'error',
    VACACIONES: 'blue',
};

const holidays = [
    { name: 'Año Nuevo', date: '01-01' },
    { name: 'Día de Reyes', date: '01-06' },
    { name: 'Día del Trabajador', date: '01-05' },
    { name: 'Asunción de la Virgen', date: '08-15' },
    { name: 'Día de la Hispanidad', date: '10-12' },
    { name: 'Día de Todos los Santos', date: '11-01' },
    { name: 'Día de la Constitución', date: '12-06' },
    { name: 'Inmaculada Concepción', date: '12-08' },
    { name: 'Navidad', date: '12-25' },
];

function dateToISOString(date) {
    return new Date(date.toISOString().substr(0, 7));
}

function clone(Obj) {
    return JSON.parse(JSON.stringify(Obj))
}

function padout(number) {
    return number < 10 ? '0' + number : number;
}

function blobPDF(resp, prefix) {
    const blob = new Blob([resp.data],
        { type: 'application/pdf' })

    var fileURL = window.URL.createObjectURL(blob)
    var fileLink = document.createElement('a')

    fileLink.href = fileURL
    fileLink.setAttribute('download', resp.headers['content-disposition'] ? resp.headers['content-disposition'].split('filename=')[1] : `${prefix}_${getDefaultStrDate(new Date())}`)
    document.body.appendChild(fileLink)

    fileLink.click();
    document.body.removeChild(fileLink)
    window.URL.revokeObjectURL(fileURL)
}

function easter(Y) {
    var C = Math.floor(Y / 100);
    var N = Y - 19 * Math.floor(Y / 19);
    var K = Math.floor((C - 17) / 25);
    var I =
        C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
    I = I - 30 * Math.floor(I / 30);
    I =
        I -
        Math.floor(I / 28) *
        (1 -
            Math.floor(I / 28) *
            Math.floor(29 / (I + 1)) *
            Math.floor((21 - N) / 11));
    var J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
    J = J - 7 * Math.floor(J / 7);
    var L = I - J;
    var M = 3 + Math.floor((L + 40) / 44);
    var D = L + 28 - 31 * Math.floor(M / 4);

    return new Date(`${Y}-${padout(M)}-${padout(D)}`);
}

function getWorkingDays(currentDate, isToday = false) {
    const HOLIDAYS_DATE = [];
    holidays.forEach(({ date }) => {
        HOLIDAYS_DATE.push(
            new Date(`${currentDate.getFullYear()}-${date}`)
        );
    });

    let daysToCheck = null;
    if (isToday) {
        daysToCheck = new Date().getDate();
    } else {
        daysToCheck = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() + 1,
            0
        ).getDate();
    }


    let workingDays = 0;
    for (let day = 1; day <= daysToCheck; day++) {
        day = String(day).length == 1 ? `0${day}` : day;
        let isoString = currentDate
            .toISOString()
            .split('T')[0]
            .split('-');
        let date = new Date(`${isoString[0]}-${isoString[1]}-${day}`);

        if (
            date.getDay() > 0 &&
            date.getDay() <= 5 &&
            !HOLIDAYS_DATE.some((el) => el.getTime() == date.getTime())
        )
            workingDays++;
        else if (
            date.getDay() == 6 &&
            !HOLIDAYS_DATE.some((el) => el.getTime() == date.getTime())
        )
            workingDays += 0.5;
        else if (
            date.getDay() == 0 &&
            HOLIDAYS_DATE.some((el) => el == date)
        )
            workingDays--;
    }

    if (
        currentDate.getMonth() ==
        easter(currentDate.getFullYear()).getMonth()
    )
        workingDays -= 2;

    return workingDays;
}

function colName(n) {
    var ordA = 'a'.charCodeAt(0);
    var ordZ = 'z'.charCodeAt(0);
    var len = ordZ - ordA + 1;

    var s = "";
    while (n >= 0) {
        s = String.fromCharCode(n % len + ordA) + s;
        n = Math.floor(n / len) - 1;
    }
    return s;
}

function swapKeysAndValues(obj) {
    return Object.fromEntries(Object.entries(obj).map(a => a.reverse()))
}

function strCamelToSnakeCase(str) {
    return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}

function strSnakeToCamelCase(str) {
    return str.replace(/_[a-z]/g, group => group.toUpperCase().replaceAll('_', ''))
}

function objectChangeCase(obj, changeCaseFunction) {
    if (typeof obj !== 'object') {
        return
    }

    let newObj

    if (Array.isArray(obj)) {
        newObj = []
        obj.forEach(innerObj => {
            newObj.push(objectChangeCase(innerObj, changeCaseFunction))
        })
    } else {
        newObj = {}
        Object.keys(obj).forEach(key => {
            if (typeof obj[key] === 'object' && obj[key] && !Array.isArray(obj[key])) {
                obj[key] = objectChangeCase(obj[key], changeCaseFunction)
            } else if (typeof obj[key] === 'object' && Array.isArray(obj[key]) && obj[key].length) {

                let newInnerArray = []

                obj[key].forEach((inner) => {
                    if (typeof inner === 'object') {
                        newInnerArray.push(objectChangeCase(inner, changeCaseFunction))
                    } else {
                        newInnerArray.push(inner)
                    }
                })

                obj[key] = newInnerArray
            }
            newObj[changeCaseFunction(key)] = obj[key]
        })
    }

    return newObj
}

function getDefaultStrDate(date) {
    return reverseDate(new Intl.DateTimeFormat('es-ES', options).format(date).replaceAll('/', '-'))
}

function todayStr() {
    let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    let verboseDate = (new Date()).toLocaleDateString('es-ES', options);

    return verboseDate.charAt(0).toUpperCase() + verboseDate.slice(1)
}

function reverseDate(dateString) {
    return dateString.split('-').reverse().join('-')
}

function objectCamelToSnakeCase(obj) {
    return objectChangeCase(obj, strCamelToSnakeCase)
}

function objectSnakeToCamelCase(obj) {
    return objectChangeCase(obj, strSnakeToCamelCase)
}

function roundXDecimals(num, decimals) {
    return parseFloat(num.toFixed(decimals))
}

function firstAndLastOfMonth() {
    return [new Date(new Date().getFullYear(), new Date().getMonth(), 2)
        .toISOString()
        .substr(0, 10),
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
        .toISOString()
        .substr(0, 10)]
}

function deleteKeyNullValues(obj) {
    if (obj == null) {
        return {}
    }

    Object.keys(obj).forEach(key => {
        if (obj[key] === null) {
            delete obj[key]
        }
        // if (typeof obj[key] === 'object') {
        //     deleteKeyNullValues(obj[key])
        // }
    })
    return obj
}

function formatDate(date) {
    if (!date) {
        return '';
    }

    let mondate = new Date(date);
    return `${mondate.getDate()}/${mondate.getMonth() + 1
        }/${mondate.getFullYear()}`;
}

function parseToFloatSpecialInteger(number) {
    return Math.round(number * 1000) / 1000
}

function convertDateToLocale(date) {
    return `${date.toLocaleString('es', {
        month: 'long',
        year: 'numeric',
    })}`;
}

function formatDateLarge(date) {
    let mondate = new Date(date);
    let options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
        timeZone: 'Europe/Madrid',
    };
    return new Intl.DateTimeFormat('es-ES', options).format(mondate);
}

function formatDateToYearMonth(date) {
    return new Date(date).toISOString().substr(0, 7);
}

function formatDateYYYYMMDD(date) {
    return date ? new Date(date).toISOString().substr(0, 10) : '-';
}

function getFirstLastDayOfMonth(date) {
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    return [firstDay, lastDay];
}

function removeEmpty(obj) {
    let red = Object.entries(obj).reduce((a, [k, v]) => {
        if (Array.isArray(v)) {
            if (!v.length)
                return a
        }
        if (v) {
            return (a[k] = v, a)
        } else {
            return a
        }
    }, {})
    return red
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function objectToArrayConverter(obj) {
    let array = []
    Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'object') {
            array.push(objectToArrayConverter(obj[key]))
        } else {
            array.push(obj[key])
        }
    })
    return array
}

function checkTimeInInterval(date1, date2) {
    const currentUTC = new Date().toUTCString();
    const currentTime = new Date(currentUTC);

    const intervalStart = new Date(currentTime);
    intervalStart.setHours(date1.getHours(), date1.getMinutes(), 0, 0);
    const intervalEnd = new Date(currentTime);
    intervalEnd.setHours(date2.getHours(), date2.getMinutes(), 0, 0);

    const currentTimeInMinutes = currentTime.getUTCHours() * 60 + currentTime.getUTCMinutes();
    const intervalStartInMinutes = intervalStart.getUTCHours() * 60 + intervalStart.getUTCMinutes();
    const intervalEndInMinutes = intervalEnd.getUTCHours() * 60 + intervalEnd.getUTCMinutes();

    return intervalStartInMinutes <= currentTimeInMinutes && currentTimeInMinutes <= intervalEndInMinutes;
}

async function getCurrentPosition(options = { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }) {
    return new Promise((resolve, reject) => {
        const success = ({ coords }) => {
            resolve({
                latitude: coords.latitude,
                longitude: coords.longitude,
                accuracy: coords.accuracy
            });
        };

        const error = (err) => {
            console.warn(`ERROR(${err.code}): ${err.message}`);
            reject(err.message);
        };

        navigator.geolocation.getCurrentPosition(success, error, options);
    });
}


export {
    clone,
    colName,
    deleteKeyNullValues,
    objectCamelToSnakeCase,
    objectSnakeToCamelCase,
    roundXDecimals,
    swapKeysAndValues,
    getDefaultStrDate,
    estadoComercial,
    easter,
    padout,
    getWorkingDays,
    dateToISOString,
    formatDate,
    formatDateLarge,
    formatDateYYYYMMDD,
    getFirstLastDayOfMonth,
    parseToFloatSpecialInteger,
    removeEmpty,
    convertDateToLocale,
    formatDateToYearMonth,
    capitalizeFirstLetter,
    firstAndLastOfMonth,
    todayStr,
    blobPDF,
    objectToArrayConverter,
    checkTimeInInterval,
    getCurrentPosition
};
